import React from 'react';
import PropTypes from 'prop-types'; // PropTypes'ı ekleyin
import styled from 'styled-components';
import { Select, Spin } from 'antd';
import { CustomImage } from './index';
import selectDown from '@src/assets/icons/icon-select-down.svg';

export const { Option: OptionSpin } = Select;

const CustomSpinSelectContent = styled(Select)(
  ({ height }) => ` 
  font-size: 16px;
  font-family: UbuntuRegular;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3f4957;
  border-radius: 4px;
  
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector{
     border-color: #0d6efd !important;
     box-shadow: 0 0 8px 1px rgba(22, 32, 86, 0.08) !important;
  }
  
  .ant-select-selector{
     height: ${height || '58'}px !important;
     padding: 14px 16px !important;
     border-radius: 4px !important;
   
    :focus{
      border-color: #0d6efd !important;
      box-shadow: 0 0 8px 1px rgba(22, 32, 86, 0.08) !important;
    }
    :hover{
      border-color: #0d6efd !important;
    }
    
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input{
       height: ${height || '58'}px !important;
    }
  }
  
  .ant-select-selection-placeholder {
    color: #6b7789;
  }
  .ant-select-selection-search {
    .ant-select-selection-search-input{
        padding: 0 5px !important;
        height: ${height || '58'}px !important;
    }
  }  
  .ant-select-arrow{
    right: 24px !important;
  }
`,
);

const SpinWrapper = styled(Spin)(
  ({ position, right, top }) => `
  position: ${position || 'absolute'};
  right: ${right || '-20px'};
  top: ${top || '10px'};
`
);

const CustomSpinSelect = ({ loading, spinPosition, spinRight, spinTop, ...props }) => {
  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <CustomSpinSelectContent {...props} suffixIcon={<CustomImage src={selectDown} />} />
      {loading && <SpinWrapper size="small" className="custom-spin" position={spinPosition} right={spinRight} top={spinTop}/>}
    </div>
  );
};

CustomSpinSelect.propTypes = {
  loading: PropTypes.bool.isRequired,
  spinPosition: PropTypes.string,
  spinRight: PropTypes.string,
  spinTop: PropTypes.string,
};

export default CustomSpinSelect;
